import { Pipe, PipeTransform } from "@angular/core";
import { parseZone } from "moment-timezone";

@Pipe({
  name: "customDate"
})
export class CustomDatePipe implements PipeTransform {
  transform(value: number, timezone: string, format = "DD MMM YYYY"): string {
    const systemTimezone = parseZone().zoneName();
    return parseZone(value)
      .tz(timezone || systemTimezone)
      .format(format);
  }
}
